/* eslint-disable @typescript-eslint/no-misused-promises */

import React from 'react'
import Image from 'next/image'
import styles from './moreDetails.module.scss'
import {
  DOWNLOAD_APP,
  KEY_FEATURES,
  SCAN_TO_DOWNLOAD,
  SCANNER_ALT,
  WIDGET_LOGO_ALT,
  WIDGET_STATUS_FALLBACK,
} from './commonConstants'
import { commonWidgetConfig } from './commonWidgetConfig'
import { onDownloadApp } from './helper'
import { FASTAG_ICON, PUC_ICON, TRAFFIC_SIGNAL_ICON } from './widgetImagesConstant'

interface KeyFeature {
  keyFeatureHighlight: string
}

const AppDownloadSection = ({
  regNo,
  widgetType,
  KeyFeatures = [] as KeyFeature[],
  segmentEventCommonProperties,
  phone,
  userData,
  vehicleData,
  isPucWidget = WIDGET_STATUS_FALLBACK.IS_PUC_WIDGET,
  pucStatus = WIDGET_STATUS_FALLBACK.IS_PUC_STATUS
}) => (
  <div className={styles.moreDetails}>
    <h4 className={styles.moreDetailsHeading}>
      {KeyFeatures[0]?.keyFeatureHighlight || KEY_FEATURES.keyDefaultHeading}
      <span> {KeyFeatures[1]?.keyFeatureHighlight || KEY_FEATURES.keyDefaultSubHeading}</span>
    </h4>
    <div className={styles.alertsWrapper}>
      <div className={styles.alertsFor}>
        <div className={styles.alertItem}>
          <Image width={24} height={24} src={TRAFFIC_SIGNAL_ICON} alt={WIDGET_LOGO_ALT.TRAFFIC_SIGNAL_ALT} />
          <p>{KeyFeatures[2]?.keyFeatureHighlight || KEY_FEATURES.keyDefaultOne}</p>
        </div>
        <div className={styles.alertItem}>
          <Image width={24} height={24} src={FASTAG_ICON} alt={WIDGET_LOGO_ALT.FASTAG_LOGO_ALT} />
          <p>{KeyFeatures[3]?.keyFeatureHighlight || KEY_FEATURES.keyDefaultTwo}</p>
        </div>
        <div className={styles.alertItem}>
          <Image width={24} height={24} src={PUC_ICON} alt={WIDGET_LOGO_ALT.PUC_LOGO_ALT} />
          <p>{KeyFeatures[4]?.keyFeatureHighlight || KEY_FEATURES.keyDefaultThree}</p>
        </div>
      </div>
      <div className={styles.scannerDownload}>
        <Image
          className={styles.scannerImg}
          width={100}
          height={100}
          src={commonWidgetConfig?.scannerImg[widgetType]}
          alt={SCANNER_ALT}
        />
        <span>{SCAN_TO_DOWNLOAD}</span>
      </div>
      <div
        className={styles.downloadBtn}
        onClick={async () =>
          await onDownloadApp({ regNo, segmentEventCommonProperties, widgetType, phone, userData, vehicleData, pucStatus, isPucWidget })
        }>
        <span>{DOWNLOAD_APP}</span>
      </div>
    </div>
  </div>
)

export default AppDownloadSection
